/* tslint:disable */
/* eslint-disable */
/**
 * Web App core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SettingTextField
 */
export interface SettingTextField {
    /**
     * 
     * @type {string}
     * @memberof SettingTextField
     */
    readonly activeData?: string;
    /**
     * 
     * @type {string}
     * @memberof SettingTextField
     */
    data?: string;
    /**
     * 
     * @type {string}
     * @memberof SettingTextField
     */
    readonly factoryDefaultData?: string;
}

/**
 * Check if a given object implements the SettingTextField interface.
 */
export function instanceOfSettingTextField(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SettingTextFieldFromJSON(json: any): SettingTextField {
    return SettingTextFieldFromJSONTyped(json, false);
}

export function SettingTextFieldFromJSONTyped(json: any, ignoreDiscriminator: boolean): SettingTextField {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'activeData': !exists(json, 'activeData') ? undefined : json['activeData'],
        'data': !exists(json, 'data') ? undefined : json['data'],
        'factoryDefaultData': !exists(json, 'factoryDefaultData') ? undefined : json['factoryDefaultData'],
    };
}

export function SettingTextFieldToJSON(value?: SettingTextField | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data,
    };
}

